'use client'

import SvgIcon from '@mui/material/SvgIcon'
import PropTypes from 'prop-types'

export const LargeSuccessIcon = ({ sx }) => {
  return (
    <SvgIcon sx={sx} data-testid="LargeSuccessIcon">
      <svg width="90" height="90" viewBox="0 0 90 90" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_281_27848)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M36.2215 68.0239C36.679 66.7459 37.8902 65.8929 39.2478 65.8929H50.7518C52.1094 65.8929 53.3206 66.7459 53.7781 68.0239L58.1921 80.3571H64.2854C66.9481 80.3571 69.1069 82.5159 69.1069 85.1786C69.1069 87.8413 66.9481 90 64.2854 90H25.714C23.0512 90 20.8926 87.8413 20.8926 85.1786C20.8926 82.5159 23.0512 80.3571 25.714 80.3571H31.8075L36.2215 68.0239Z"
            fill="#5073C3"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M64.8566 9.64285H6.42857C2.87817 9.64285 0 12.5211 0 16.0714V67.5C0 71.0505 2.87817 73.9286 6.42857 73.9286H83.5714C87.1219 73.9286 90 71.0505 90 67.5V19.3767L69.5051 44.9958C65.1664 50.4185 57.3063 51.4164 51.7508 47.2497L38.8936 37.6068C33.213 33.3463 32.0617 25.2875 36.3222 19.6068C40.5827 13.9262 48.6415 12.7749 54.3222 17.0354L57.21 19.2013L64.8566 9.64285Z"
            fill="#D8DCE5"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M88.1914 1.0567C90.2704 2.72014 90.6079 5.75423 88.9442 7.83354L63.2299 39.9764C61.6031 42.0099 58.6555 42.3841 56.5721 40.8216L43.715 31.1788C41.5847 29.5811 41.153 26.559 42.7507 24.4288C44.3484 22.2985 47.3704 21.8668 49.5007 23.4645L58.6194 30.3035L81.4144 1.80968C83.0781 -0.269615 86.1118 -0.606736 88.1914 1.0567Z"
            fill="#5073C3"
          />
        </g>
        <defs>
          <clipPath id="clip0_281_27848">
            <rect width="90" height="90" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </SvgIcon>
  )
}

LargeSuccessIcon.propTypes = {
  sx: PropTypes.object
}
